import { getCookie } from '@atlassian/browser-storage-controls';

export const CSRF_COOKIE_NAME = 'csrftoken';
export const CSRF_HEADER_NAME = 'X-CSRFToken';

export const isSameDomain = (url: string): boolean =>
	/^(?!https?:)/.test(url) || url.indexOf(window.location.origin) === 0;

const getRequestHeaders = (url: string, csrftoken: string) => {
	const headers: HeadersInit = {};

	// never send tokens cross-(sub)domain
	if (isSameDomain(url)) {
		headers[CSRF_HEADER_NAME] = csrftoken;
	}

	return headers;
};

export default function authRequest(
	url: string,
	options: RequestInit = {},
	csrftoken: string = getCookie(CSRF_COOKIE_NAME) || '',
): Request {
	const headers = getRequestHeaders(url, csrftoken);

	return new Request(url, {
		credentials: 'same-origin',
		...options,
		headers: {
			...headers,
			...(options.headers || {}),
		},
	});
}
